function format(date) {
	var date = new Date(date);
	var Y = date.getFullYear() + '-';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var D = date.getDate() + ' ';
	var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
	var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
	var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
	// var m = date.getMinutes() + ':';
	// var s = date.getSeconds();
	var a = Y + M + D + h + m + s;
	return a;
}


// const redirectUrl = 'http://www.astrobursthub.cn/'
const redirectUrl = 'http://tianwen.dev.vrsea.cn/'
export {
	format,
	redirectUrl
}